export default "__VITE_ASSET__y62kw_D9__"